module.exports = __webpack_public_path__ + "img/aeroland_slider-sass-image-03.7365e499.png";